import React from "react";
import { Box } from "@mui/material";
import Table from "./content/Table";

interface Props {
  tabSelected: string;
  setTabSelected: React.Dispatch<React.SetStateAction<string>>;
}

export const Reports = ({ tabSelected, setTabSelected }: Props) => {
  return (
    <Box paddingLeft={5} paddingTop={3} width={"100%"}>
      <Table
        {...{
          tabSelected,
          setTabSelected,
        }}
      />
    </Box>
  );
};
